export const blockToFormData = (block) => {
	if (!block) return undefined;

	const {linkedArticles, ...rest} = block;
	return {
		...rest,
		linked: linkedArticles.map((linked => ({
			id: linked.article.id,
			title: linked.article.title,
			customTitle: linked.title || ''
		})))
	}
}

export const formDataToParams = (formData, extraParams = {}) => {
	const {linked, ...rest} = formData;

	return {
		...rest,
		...extraParams,
		linkedArticles: linked.map(item => {
			const {customTitle} = item;
			return {
				articleId: item.id,
				title: customTitle && customTitle !== '' ? customTitle : item.title
			}
		})
	}
}


// WEBPACK FOOTER //
// src/components/blocks/utils.js